export const CSAT_BASE_PATH = '/customer-satisfaction';
export const CSAT_DASHBOARD_PATH = '/customer-satisfaction/dashboard';
export const CSAT_SURVEYS_PATH = '/customer-satisfaction/surveys';
export const CSAT_CREATE_PATH = '/customer-satisfaction/campaigns/create';

/**
 * @param {string} campaignId
 * @returns {string}
 */
export function csatCampaignResultsPath(campaignId: string): string {
  return `/customer-satisfaction/campaigns/${campaignId}`;
}

/**
 * Demo edit path — reuses create wizard for mock phase A.
 * @param {string} campaignId
 * @returns {string}
 */
export function csatCampaignEditPath(campaignId: string): string {
  return `/customer-satisfaction/campaigns/edit/${campaignId}`;
}

/**
 * Per-campaign embed preview (not a module tab).
 * @param {string} campaignId
 * @returns {string}
 */
export function csatCampaignEmbedPath(campaignId: string): string {
  return `/customer-satisfaction/campaigns/${campaignId}/embed`;
}

/**
 * Per-campaign take preview for iframe / demo (not a module tab).
 * @param {string} campaignId
 * @returns {string}
 */
export function csatCampaignTakePath(campaignId: string): string {
  return `/customer-satisfaction/campaigns/${campaignId}/take`;
}
